"use client";

import { useSyncExternalStore } from "react";
import { connectivityStore } from "./connectivity-store";

export function useConnectivity() {
	return useSyncExternalStore(
		connectivityStore.subscribe,
		connectivityStore.getSnapshot,
		connectivityStore.getServerSnapshot,
	);
}
